export default __webpack_public_path__ + "static/media/ice_and_gelato.7ae65d06.jpg";